import commonAxios from "../libs/commonAxios";

export const StoreInfoApi = async (store_id, setStoreInfo, setLoading) => {
    try {
        const response = await commonAxios('POST', {
            "id": store_id
        }, '/store/api/store_info');
        setLoading(false);
        setStoreInfo(response.data.data.result);
    } catch (error) {
        setLoading(false);
        alert("매장 정보가 존재하지 않습니다. 다시 시도해 주세요");
    }

}

export const StoreSearchApi = async (mcpnm, search_info, setStoreList) => {
    try {
        const response = await commonAxios('POST', {
            "mcpnm": mcpnm,
            "region": search_info.area,
            "search": search_info.search_text
        }, '/store/api/store_search');
        setStoreList(response.data.data.result);
    } catch (error) {
        if (error.response.status === 401) {
            alert("정상적인 접근이 아닙니다. 다시 시도해 주세요.");
        } else if (error.response.status === 402) {
            alert("정상적인 접근이 아닙니다. 다시 시도해 주세요.");
        } else {

        }
    }
}
